import React from 'react';
import { ChatDto, ChatStatus, STATUS_FILTER_OPTIONS, STATUS_LABELS } from '../models/support';
import './ChatList.css';

interface ChatListProps {
    chats: ChatDto[];
    selectedTgId: string | null;
    statusFilter: ChatStatus | 'ALL';
    onSelect: (tgId: string) => void;
    onFilterChange: (status: ChatStatus | 'ALL') => void;
}

function lastMessage(chat: ChatDto): string {
    if (chat.messages.length === 0) return '—';
    const last = chat.messages[chat.messages.length - 1];
    return last.content.length > 40
        ? last.content.slice(0, 40) + '…'
        : last.content;
}

const STATUS_CLASS: Record<ChatStatus, string> = {
    AUTO: 'badge--auto',
    WAITING_HUMAN: 'badge--waiting',
    HUMAN: 'badge--human',
    CLOSED: 'badge--closed',
};

export const ChatList: React.FC<ChatListProps> = ({
    chats,
    selectedTgId,
    statusFilter,
    onSelect,
    onFilterChange,
}) => {
    const filtered = chats
        .filter(c => statusFilter === 'ALL' || c.status === statusFilter)
        .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

    return (
        <div className="chat-list">
            <div className="chat-list__filters">
                {STATUS_FILTER_OPTIONS.map(opt => (
                    <button
                        key={opt.value}
                        className={`chat-list__filter-btn ${statusFilter === opt.value ? 'chat-list__filter-btn--active' : ''}`}
                        onClick={() => onFilterChange(opt.value)}
                    >
                        {opt.label}
                    </button>
                ))}
            </div>

            <div className="chat-list__items">
                {filtered.length === 0 && (
                    <div className="chat-list__empty">Нет чатов</div>
                )}
                {filtered.map(chat => (
                    <button
                        key={chat.tgId}
                        className={`chat-list__item ${selectedTgId === chat.tgId ? 'chat-list__item--active' : ''}`}
                        onClick={() => onSelect(chat.tgId)}
                    >
                        <div className="chat-list__item-header">
                            <span className="chat-list__username">@{chat.username}</span>
                            <span className={`chat-list__badge ${STATUS_CLASS[chat.status]}`}>
                                {STATUS_LABELS[chat.status]}
                            </span>
                        </div>
                        <div className="chat-list__preview">{lastMessage(chat)}</div>
                    </button>
                ))}
            </div>
        </div>
    );
};
